(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["jiwentang-product"] && !Shopify.designMode) return;
  try {
    
/* ═══════════════════════════════════════
   己文堂 — 商品頁 JS
   ═══════════════════════════════════════ */
(function () {
  const data     = window.jwProductData;
  if (!data) return;

  // ── 選中的 option 狀態 ──
  const selectedOptions = {};

  // 初始化：從 DOM 讀取已 selected 的按鈕
  document.querySelectorAll('.jw-option__btn.is-selected').forEach(btn => {
    selectedOptions[btn.dataset.optionIndex] = btn.dataset.value;
  });
  // 單一規格商品不渲染選擇器，改以唯一變體作為預設選取
  if (!Object.keys(selectedOptions).length && data.variants.length === 1) {
    data.options.forEach((_, i) => { selectedOptions[i] = data.variants[0][`option${i + 1}`]; });
  }

  // ── 尋找符合的 variant ──
  function findVariant() {
    return data.variants.find(v =>
      data.options.every((_, i) => v[`option${i + 1}`] === selectedOptions[i])
    );
  }

  // ── 更新 UI ──
  function updateUI(variant) {
    if (!variant) return;

    const available = variant.available;
    const atcBtn  = document.getElementById('jw-add-to-cart');
    const buyBtn  = document.getElementById('jw-buy-now');
    const btnPrice = document.getElementById('jw-btn-price');

    // 價格
    const price = (variant.price / 100).toLocaleString('zh-TW', { style: 'currency', currency: 'TWD', maximumFractionDigits: 0 });
    document.querySelector('.jw-price').textContent = price;
    if (btnPrice) btnPrice.textContent = price;

    // 原價
    const compareEl = document.querySelector('.jw-price--compare');
    const badgeEl   = document.querySelector('.jw-price--badge');
    if (compareEl) {
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        const comparePrice = (variant.compare_at_price / 100).toLocaleString('zh-TW', { style: 'currency', currency: 'TWD', maximumFractionDigits: 0 });
        compareEl.textContent = comparePrice;
        compareEl.style.display = '';
        if (badgeEl) {
          const pct = Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100);
          badgeEl.textContent = `早鳥 -${pct}%`;
          badgeEl.style.display = '';
        }
      } else {
        compareEl.style.display = 'none';
        if (badgeEl) badgeEl.style.display = 'none';
      }
    }

    // 按鈕狀態
    atcBtn.dataset.variantId = variant.id;
    buyBtn.dataset.variantId = variant.id;
    atcBtn.disabled = !available;
    buyBtn.disabled = !available;
    if (atcBtn.querySelector('span')) {
      atcBtn.innerHTML = available
        ? `加入購物袋 · <span id="jw-btn-price">${price}</span>`
        : '已售完';
    }

    // 尺寸較長提醒（無法超商取貨）
    const longNote = document.getElementById('jw-long-note');
    if (longNote) {
      const keywords = longNote.dataset.keywords.split(',').filter(Boolean);
      longNote.hidden = !keywords.some(k => variant.title.includes(k));
    }

    // 主圖（如果 variant 有指定圖片）
    if (variant.featured_image) {
      updateMainImage(variant.featured_image.src);
    }
  }

  // ── 選項點擊 ──
  document.querySelectorAll('.jw-option__btn').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = btn.dataset.optionIndex;
      // 同一 option 組先清除 selected
      document.querySelectorAll(`.jw-option__btn[data-option-index="${idx}"]`)
        .forEach(b => b.classList.remove('is-selected'));
      btn.classList.add('is-selected');
      selectedOptions[idx] = btn.dataset.value;

      const variant = findVariant();
      if (variant) updateUI(variant);
    });
  });

  // ── 數量按鈕 ──
  const qtyInput = document.getElementById('jw-qty-input');
  document.getElementById('jw-qty-minus')?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value, 10);
    if (v > 1) qtyInput.value = v - 1;
  });
  document.getElementById('jw-qty-plus')?.addEventListener('click', () => {
    const v = parseInt(qtyInput.value, 10);
    qtyInput.value = v + 1;
  });

  // ── 加入購物袋 ──
  document.getElementById('jw-add-to-cart')?.addEventListener('click', async function () {
    const variantId = parseInt(this.dataset.variantId, 10);
    const qty       = parseInt(qtyInput.value, 10) || 1;
    this.textContent = '加入中…';
    this.disabled = true;

    try {
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: qty })
      });
      if (!res.ok) throw new Error('加入失敗');
      // 可在此觸發 mini-cart 更新事件
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) { document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'custom-add-btn', data: { source: 'custom-add-btn', itemCount: cart.item_count } } })); });
      this.textContent = '✓ 已加入';
      setTimeout(() => {
        this.disabled = false;
        const variant = findVariant();
        if (variant) updateUI(variant);
      }, 1800);
    } catch (e) {
      this.textContent = '加入失敗，請重試';
      this.disabled = false;
    }
  });

  // ── 立即購買 ──
  document.getElementById('jw-buy-now')?.addEventListener('click', async function () {
    const variantId = parseInt(this.dataset.variantId, 10);
    const qty       = parseInt(qtyInput.value, 10) || 1;
    await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: qty })
    });
    window.location.href = '/cart';
  });

  // ── Gallery 縮圖切換 ──
  function updateMainImage(src) {
    const mainImg = document.getElementById('jw-main-image');
    if (!mainImg) return;
    mainImg.style.opacity = '0.5';
    mainImg.src = src;
    mainImg.onload = () => { mainImg.style.opacity = '1'; };
  }

  document.querySelectorAll('.jw-thumb').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.jw-thumb').forEach(b => b.classList.remove('is-active'));
      btn.classList.add('is-active');
      updateMainImage(btn.dataset.src);
    });
  });

})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }



  } catch(e) { console.error(e); }
})();
})();
